module.exports = __webpack_public_path__ + "img/a48253b.png";